<template>
  <transition name="component-fade" mode="out-in">
    <Spinner class="mt-4" key="1" v-if="loading"></Spinner>
    <div v-else key="2">
      <div class="mb-4" v-if="topic">
        <div class="d-flex">
          <h3>{{ topic.title }}</h3>
          <div class="ms-auto">
            <CommunityNotifications :topic="topic.id"></CommunityNotifications>
          </div>
        </div>
        <div class="d-lg-none">
          <p>{{ topic.description }}</p>
        </div>
      </div>
      <div v-else class="mb-4 d-flex">
        <h3>{{ 'All' | translate }}</h3>
      </div>
      <PostCreate
        v-if="studentsCanPost"
        :topic="topic"
        @postCreated="postCreated"
      ></PostCreate>
      <div v-if="noPosts" class="text-center">
        <img
          class="w-50 mt-5 mb-3"
          src="/images/undraw_empty_xct9.svg"
          alt=""
        />
        <h3 class="fw-light">
          {{ 'Oops... Nothing here yet' | translate }}
        </h3>
      </div>
      <div v-else>
        <Post v-for="post in posts" :key="post.id" :post="post"></Post>
      </div>
      <div class="d-grid">
        <button
          v-if="next_page_url"
          @click="loadMorePosts"
          class="btn btn-link"
          :disabled="loadingMore"
        >
          <transition name="component-fade" mode="out-in">
            <span v-if="loadingMore">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Loading...</span>
            </span>
            <span v-else>{{ 'More' | translate }}</span>
          </transition>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import Spinner from '~/app2/components/Spinner'
import Post from '~/web-components/community/Post'
import PostCreate from '~/web-components/community/PostCreate'
import CommunityNotifications from '~/app2/components/community/CommunityNotifications.vue'
import _ from 'lodash'

export default {
  props: ['topicId'],
  components: {
    CommunityNotifications,
    Spinner,
    Post,
    PostCreate,
  },
  data() {
    return {
      loading: true,
      posts: [],
      topic: null,
      next_page_url: null,
      loadingMore: false,
    }
  },
  mounted() {
    this.getPosts()
  },
  computed: {
    studentsCanPost() {
      return _.get(this.topic, 'allow_students_to_add_posts', false)
    },
    noPosts() {
      return _.isEmpty(this.posts)
    },
  },
  methods: {
    postCreated(data) {
      this.posts = [data, ...this.posts]
    },
    loadMorePosts() {
      if (!this.next_page_url) {
        return null
      }
      this.loadingMore = true
      return axios.post(this.next_page_url).then(({ data }) => {
        this.posts = [...this.posts, ...data.community_posts.data]
        this.next_page_url = this.setSameProtocol(
          data.community_posts.next_page_url,
        )
        this.loadingMore = false
        return data
      })
    },
    setSameProtocol(url) {
      return _.replace(url, 'http:', location.protocol)
    },
    getPosts() {
      const url = this.topicId
        ? `/json/community/topics/${this.topicId}`
        : '/json/community'

      axios.post(url).then(({ data }) => {
        this.posts = [...this.posts, ...data.community_posts.data]
        this.topic = data.community_topic
        this.next_page_url = this.setSameProtocol(
          data.community_posts.next_page_url,
        )
        this.loading = false
      })
    },
  },
}
</script>

<style></style>
